const GTM_ID = 'GTM-TJXMD6R4'
const SCRIPT_ID = 'promote-gtm-script'
const NOSCRIPT_ID = 'promote-gtm-noscript'

/**
 * Loads Google Tag Manager only while the promote page is mounted.
 * Shares `window.dataLayer` with the existing site-wide GA4 gtag snippet.
 */
export const installPromoteGtm = (): (() => void) => {
  if (typeof document === 'undefined') {
    return () => undefined
  }

  if (!document.getElementById(SCRIPT_ID)) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.insertBefore(script, document.head.firstChild)
    }
  }

  if (!document.getElementById(NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript')
    noscript.id = NOSCRIPT_ID
    const iframe = document.createElement('iframe')
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'
    noscript.appendChild(iframe)
    document.body.insertBefore(noscript, document.body.firstChild)
  }

  return () => {
    document.getElementById(SCRIPT_ID)?.remove()
    document.getElementById(NOSCRIPT_ID)?.remove()
  }
}
